import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const ASE_HISTORY_FETCH_PENDING = 'ASE_HISTORY_FETCH_PENDING';

export const fetchAseHistoryPageData = (pageSize, sorted, cursor, isNextFromPivot, filtered) => dispatch => {
    dispatch({
        type: ASE_HISTORY_FETCH_PENDING,
        aseWebsocket: true,
        command: aseWebsocketCommands.ASE_HISTORY_GET,
        payload: {pageSize: pageSize, sorted: sorted, cursor, isNextFromPivot, filtered: filtered}
    });
};
